import type { Series, Status } from '../api/types'

export const STATUS_LABEL: Record<Status, string> = {
  idea: 'Idea',
  scripted: 'Scripted',
  filmed: 'Filmed',
  edited: 'Edited',
  published: 'Published',
  killed: 'Killed',
}

/**
 * The order the pipeline shows its sections in: closest to done first.
 *
 * Linear's order, where in-progress work sits above the backlog. Here the
 * backlog is `idea`, and it is most of the list, so running the loop front to
 * back would put a reel waiting to be published forty rows down. An edited
 * reel is the one thing on this screen that only Martin can move, so it goes
 * first; published is finished work and goes last.
 */
export const PIPELINE_ORDER: Status[] = ['edited', 'filmed', 'scripted', 'idea', 'published']

/** The loop in the order it runs, for pickers and for cycling a chip. */
export const LOOP_ORDER: Status[] = ['idea', 'scripted', 'filmed', 'edited', 'published']

export const SERIES_LABEL: Record<Series, string> = {
  profit: 'Profit',
  agents: 'Agents',
  books: 'Books',
}

export { CHANNEL_LABEL, FORMAT_LABEL, VOLUME_FORMATS } from './formats'
